import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    max-width: 7.125rem;
    min-width: 2.125rem;
    height: 2.125rem;
    color: ${COLORS.WHITE};
    ${pickThemeFontStyles('12', '14', 'BOLD')};

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledUrl = styled.a<{ $isActive?: boolean }>`
  &&& {
    cursor: ${({ $isActive }) => ($isActive ? 'pointer' : 'auto')};
  }
`;
